import { Avatar, Card, Timeline, Typography } from 'antd';
import moment from 'moment';
import React from 'react';
import './style.css';

const Historial = ({ autorizacionesDet, mode }) => {
  const getState = (comentario) => {
    if (comentario) return 'orange';
    return 'green';
  };

  const getRol = (usuario) => {
    if (usuario.grupo === 'ADMIN_EMPRESA')
      return (
        <span style={{ width: 'inherit' }}>
          {usuario.nombres} - Gerente Empresa
        </span>
      );
    if (usuario.grupo === 'ADMIN_SUCURSAL')
      return (
        <span style={{ width: 'inherit' }}>
          {usuario.nombres} - Gerente Sucursal
        </span>
      );
    if (usuario.grupo === 'EJECUTIVO')
      return (
        <span style={{ width: 'inherit' }}>{usuario.nombres} - Ejecutivo</span>
      );
    if (usuario.grupo === 'ADMIN_ASEGURADORA')
      return (
        <span style={{ width: 'inherit' }}>
          {usuario.nombres} - Gerente Aseguradora
        </span>
      );
    if (usuario.grupo === 'EJECUTIVO_ASEGURADORA')
      return (
        <span style={{ width: 'inherit' }}>
          {usuario.nombres} - Ejecutivo Aseguradora
        </span>
      );
    if (usuario.grupo === 'ADMIN')
      return (
        <span style={{ width: 'inherit' }}>
          {usuario.nombres} - Admin General
        </span>
      );
    return '';
  };

  if (autorizacionesDet.length === 0) {
    return (
      <div style={{ textAlign: 'start' }}>
        <Typography.Text>No hay datos</Typography.Text>
      </div>
    );
  }
  return (
    <div className="timeline_container">
      <Timeline mode={mode}>
        {autorizacionesDet.map((detalle) => {
          const estado = getState(detalle.comentario);
          return (
            <Timeline.Item
              label={<> {moment(detalle.fecha).format('DD/MM/YYYY HH:mm')}</>}
              color={estado}
              position="left"
              key={detalle.id}
            >
              <Card.Meta
                avatar={<Avatar>{detalle.usuario.nombres[0]}</Avatar>}
                title={getRol(detalle.usuario)}
                description={detalle.comentario}
              />
            </Timeline.Item>
          );
        })}
      </Timeline>
    </div>
  );
};

export default Historial;
